import React from 'react'
import ForgetPassword from '../../modules/ForgetPassword'

const ForgetPasswordPage = () => {
    return <ForgetPassword />
}

export default ForgetPasswordPage